
import * as mutationTypes from '@/store/mutation-types'

export default function Log({ to, store }) {
  console.log(to.name)
  store.commit(`main/${mutationTypes.SET_PAGE}`, to)
}
